import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { getControlStyle } from '../../../../../Components/helper';
import CommonAction from './CommonAction';
import { DurationCounterIcon } from '../../../../../bombiix-icon';
import { NewInput } from '../../../../../Components/PIM/common/NewInput';

export function Timepicker({
  label,
  disable,
  error,
  fromForm,
  duplicatingItem,
  gridIndex,
  pageIndex,
  value,
  editingInput,
  showDelete,
  deleteItem,
  onChange,
  placeHolder,
  supplierVisible,
  handleSupplierPermission,
  otherConfiguration,
  setParentGridZIndex,
  setOnElement,
  onElement,
  handleStaticGrid,
  isStatic,
  boldLabel,
  gridY,
}) {
  const handleDuplicateItem = () => {
    duplicatingItem(gridIndex, pageIndex);
    setOnElement(false);
  };
  const timeSelectd = value ? new Date(value) : null;
  const combinedStyles = getControlStyle(otherConfiguration);

  function Input({ onChange, placeholder, value, isSecure, id, onClick }) {
    return (
      <NewInput
        type="text"
        onChange={onChange}
        className="pr-4"
        style={combinedStyles}
        placeholder={placeholder}
        value={value}
        isSecure={isSecure}
        id={id}
        onClick={onClick}
      />
    );
  }

  const handleCalendarOpen = () => {
    setParentGridZIndex(true, gridIndex);
  };

  const handleCalendarClose = () => {
    setParentGridZIndex(false, gridIndex);
  };
  return (
    <div className="dt_picker position-relative">
      <p className={`asterisk-req fs-custom-module mb-0 ${fromForm && 'd-flex'} ${boldLabel && 'font-weight-bold'}`}>{label}</p>
      <DatePicker
        placeholderText={placeHolder}
        disabled={disable}
        timeCaption="Time"
        popperPlacement={gridY > 30 ? 'top-end' : 'bottom-end'}
        customInput={<Input />}
        showTimeSelect
        selected={timeSelectd}
        timeIntervals={5}
        timeFormat="HH:mm"
        dateFormat="HH:mm"
        showTimeSelectOnly
        onCalendarOpen={handleCalendarOpen} // Pass onCalendarOpen prop
        onCalendarClose={handleCalendarClose} // Pass onCalendarClose prop
        onChange={(e) => onChange(e, label, gridIndex, pageIndex)}
      />
      <button aria-label="Time" type="button" className="btn-calender btn custom-time-icon">
        <DurationCounterIcon size={24} />
      </button>

      {fromForm && onElement && (
        <CommonAction
          editingInput={editingInput}
          gridIndex={gridIndex}
          pageIndex={pageIndex}
          showDelete={showDelete}
          deleteItem={deleteItem}
          handleDuplicateItem={handleDuplicateItem}
          supplierVisible={supplierVisible}
          handleSupplierPermission={handleSupplierPermission}
          handleStaticGrid={handleStaticGrid}
          isStatic={isStatic}
        />
      )}
      {error?.status && <span className="error-message">{error.errorMsg}</span>}
    </div>
  );
}
export default Timepicker;
